export enum AWARD_CODES {
  TWO_TIME_CASH_INCENTIVE = 3,
  COMEBACK_TTCI = 1003,
  PERFORMANCE_BONUS = 4,
  MONTHLY_PERFORMANCE = 6,
  HAT = 8,
  GAR = 29,
  FAA = 9,
  PERFORMANCE_BONUS_PERSONAL = 10,
  MGD = 11,
  ACTION_REPORTS = 12,
  EARNINGS_CALCULATOR = 13,
  CML = 14,
  PERFORMANCE_BONUS_DIFFERENTIAL = 15,
  CUSTOMER_OVERVIEW = 142,
  EDLOS = 150,
  LOS = 16,
  LEARN_ABOUT_CPP = 17,
  WATCHLIST = 18,
  BRONZE_GROUP_TRACKING = 19,
  RUBY = 20,
  LEADERSHIP = 30,
  FOSTER = 40,
  DEPTH = 50,
  INTERNATIONAL_LEADERSHIP = 130,
  EMERALD = 370,
  DIAMOND = 380,
  DIAMOND_PLUS = 381,
  STRONG_START_INCENTIVE = 533,
  STRONG_START_INCENTIVE_MONTH = 534,
  STRONG_START_INCENTIVE_MONTH_V2 = 537,
  SSIV2 = 538,
  LSI = 700,
  CSI = 925,
  CSI_PERCENTAGE_CHINA = 928,
  BRONZE_FOUNDATION = 930,
  BRONZE_BUILDER = 931,
  MN_BRONZE_FOUNDATION = 924,
  MN_BRONZE_BUILDER = 928,
  FIXED_PAYMENT = 933, // BBI consistency payment code
  BRONZE_FOUNDATION_FIXED_PAYMENT = 936, // BFI consistency payment code
  MONTHLY_Q = 942,
  Q_GROWTH_INCENTIVE = 943,
  RESTART_BRONZE_FOUNDATION = 948,
  RESTART_BRONZE_BUILDER = 949,
  RESTART_TWO_BRONZE_FOUNDATION = 952,
  RESTART_TWO_BRONZE_BUILDER = 953,
  PERFORMANCE_PLUS = 940,
  PERFORMANCE_ELITE = 945,
  PERFORMANCE_PLUS_ELITE = 940945,
  MONTHLY_PGG = 954,
  ANNUAL_PGG = 955,
  PGG_KICKER = 956,
  PGTI = 985,
  PQ_MONTH = 958,
  PGG_GCR = 959,
  FGG = 960,
  FRONTLINE_Q = 960,
  LEADERSHIP_PLUS = 960,
  FGG_KICKER = 961,
  FGG_PLATINUM_DETAILS = 962,
  QC_GROWTH = 981,
  PATH_TO_BRONZE = 530,
  NEW_PATH_TO_BRONZE = 535,
  MBI = 143,
  BRONZE_INCENTIVES = 1010,
  VISION_BONUS_TRACKING_YEAR = 963,
  VISION_BONUS_QUALIFICATION_YEAR = 964,
  HEALTH_WELLBEING = 997,
  OTCI = 2003,
  SHOW_SSI_UPLINE = 27,
  RETRO_PV_INQUIRY = 28,
  ANNUALQ = 955,
  DIAMOND_BONUS = 994,
  TTCA = 4003,
  FOUNDERS_SALES_INCENTIVE = 556,
}

export enum TTCI_AWARD_CODES {
  SILVER = 968,
  GOLD = 969,
  PLATINUM = 970,
  FOUNDERS_PLATINUM = 971,
  SAPPHIRE = 972,
  FOUNDERS_SAPPHIRE = 973,
  IN_MARKET_EMERALD = 974,
  IN_MARKET_FOUNDERS_EMERALD = 975,
  IN_MARKET_DIAMOND = 976,
  IN_MARKET_FOUNDERS_DIAMOND = 977,
  A70_IN_MARKET_EMERALD = 990,
  A70_IN_MARKET_FOUNDERS_EMERALD = 991,
  A70_IN_MARKET_DIAMOND = 992,
  A70_IN_MARKET_FOUNDERS_DIAMOND = 993,
  COMEBACK_PLATINUM = 1970,
  COMEBACK_FOUNDERS_PLATINUM = 1971,
  COMEBACK_SAPPHIRE = 1972,
  COMEBACK_FOUNDERS_SAPPHIRE = 1973,
  COMEBACK_EMERALD = 1974,
  COMEBACK_FOUNDERS_EMERALD = 1975,
  COMEBACK_DIAMOND = 1976,
  COMEBACK_FOUNDERS_DIAMOND = 1977,
  OTCI = 2003,
  OTCI_GOLD = 1979,
  OTCI_PLATINUM = 1980,
  OTCI_EMERALD = 1984,
  OTCI_DIAMOND = 1986,
}

export type BRONZE_AWARD_NUMS =
  | AWARD_CODES.BRONZE_FOUNDATION
  | AWARD_CODES.BRONZE_BUILDER
  | AWARD_CODES.RESTART_BRONZE_FOUNDATION
  | AWARD_CODES.RESTART_BRONZE_BUILDER;
